import { callApiWithAuthorization } from "../CallApi";

export async function generatePageConfiguration(projectId) {
	try {
		const request = await callApiWithAuthorization("/api/v0/project/" + projectId + "/generatePagesFromConfigurations", {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify({
				projectId
			})
		})
		const response = await request.text();
		return [response, null]
	} catch (e) {
		return [null, e.message];
	}
}

export async function generateIncrementalChanges(projectId, organizationId, publisherId, instanceId, forPreview, forImport) {
	try {
		const request = await callApiWithAuthorization(
			"/api/v0/project/" + projectId + "/incrementalPublish",
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					projectId,
					organizationId,
					publisherId,
					instanceId,
					forPreview,
					forImport
				}),
			}
		);
		const response = await request.blob();
		return [response, null];
	} catch (e) {
		return [null, e.message];
	}
}

export async function removePortalCreatedPages(projectId) {
	try {
		const request = await callApiWithAuthorization("/api/v0/project/" + projectId + "/removePortalPages", {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify({
				projectId: projectId
			})
		});
		const response = await request.json();
		return [response, null];
	} catch (e) {
		return [null, e.message];
	}
}

export async function removePortalItems(projectId) {
	try {
		const request = await callApiWithAuthorization("/api/v0/project/" + projectId + "/removeAllPortalItems", {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify({
				projectId: projectId
			})
		});
		const response = await request.json();
		return [response, null];
	} catch (e) {
		return [null, e.message];
	}
}

export async function removePlaceholderLinks(projectId) {
	try {
		const request = await callApiWithAuthorization("/api/v0/project/" + projectId + "/deleteTempLinks", {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify({
				projectId: projectId
			})
		});
		const response = await request.json();
		return [response, null];
	} catch (e) {
		return [null, e.message];
	}
}

export async function linkNewAttributeToComponent(projectId, data) {
	try {
		const request = await callApiWithAuthorization("/api/v0/project/" + projectId + "/linkComponentWithNewAttribute", {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify({
				data
			})
		});
		const response = await request.json();
		return [response, null];
	} catch (e) {
		return [null, e.message];
	}
}

export async function validateForPublish(projectId, instanceType) {
	const request = await callApiWithAuthorization(
		"/api/v0/project/" + projectId + "/validateForPublish",
		{
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				instanceType,
				projectId,
			}),
		}
	);
	const response = await request.json();
	return response;
}

export async function checkProjectForDisplayPages(projectId) {
	const request = await callApiWithAuthorization(
		"/api/v0/project/" + projectId + "/hasDisplayPages"
	);
	const response = await request.json();
	return response.hasPages;
}

export async function removeAllChanges(projectId) {
	const request = await callApiWithAuthorization("/api/v0/project/" + projectId + "/removeAllChanges", {
		method: "DELETE"
	});
	const response = await request.json();
	return response;
}

export const performIncrementalGeneration = async (projectId, organizationId, userId, instanceId) => {
	const [compressedJson, generationError] = await generateIncrementalChanges(
		projectId,
		organizationId,
		userId,
		instanceId,
		false,
		false
	);
	await removeAllChanges(projectId);
	return compressedJson;
};

export const performFullGeneration = async (projectId) => {
	const [generationResponse, generationError] = await generatePageConfiguration(projectId);
	if (generationError !== null) {
		throw new Error(generationError);
	}
	await removePlaceholderLinks(projectId);
	await removeAllChanges(projectId);
	return generationResponse;
};